import PropTypes from "prop-types"
import React from "react"

import { Helmet } from "react-helmet"

function PageMeta({ title, description, currentUrl, noIndexFollow }) {
  return (
    <Helmet>
      <html lang="en-GB" />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={currentUrl} />
      {noIndexFollow && <meta name="robots" content="noindex, follow" />}
      <script>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id=GTM-MMK47HB'+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MMK47HB');
      `}
      </script>
      <link
        rel="preload"
        href="https://media.reviews.co.uk/badge/caresourcer-com1.png"
        as="image"
      />
      <link
        rel="preload"
        href="https://www.googletagmanager.com/gtm.js?id=GTM-ND42JK9"
        as="script"
      />
      <link
        rel="preload"
        href="https://www.googletagmanager.com/gtm.js?id=GTM-MMK47HB"
        as="script"
      />
      <link
        rel="preload"
        href="https://www.google-analytics.com/analytics.js"
        as="script"
      />
      <link rel="preconnect" href="https://cc.cdn.civiccomputing.com" />
      <link rel="preconnect" href="https://cdn.amplitude.com" />
      <link rel="preconnect" href="https://api.amplitude.com" />
      <link rel="preconnect" href="https://www.googleadservices.com" />
      <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
    </Helmet>
  )
}
PageMeta.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  currentUrl: PropTypes.string.isRequired,
  noIndexFollow: PropTypes.bool,
}

PageMeta.defaultProps = {
  noIndexFollow: false,
  description: null,
}

export default PageMeta
